import { createSlice } from '@reduxjs/toolkit';
import { getCampaignProviderSource } from '../utils/campaignProviderSource';

const initialState = {
    id: null,
    //Wizard basics
    name: '',
    brand: '',
    channels: {
        isDOOH: true,
        isMobile: false,
        isTV: false,
    },
    budget: {
        budget: 0,
        cpm: 0,
        cpmOptimizer: true,
    },
    reduction: {
        reduction: undefined,
    },
    dailyCap: {
        isActive: false,
        isDistribution: false,
        isBudget: true,
        budget: 0,
        isImpressions: false,
        impressions: 0,
    },
    dailyCaps: {
        isActive: false,
        caps: {},
    },
    timing: {
        isDayParting: false,
        periodValue: null,
        selectedTimezone: '',
        timezones: [],
        strategy: 'evenly', // 'evenly' | 'asap' | 'exclusivity' | 'optimizer' | 'inferred_path'
        isCellSelected: {
            cells: [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                ],
            ],
        },
        daysEnabled: [],
        hoursEnabled: '',
        hoursOfWeek: [],
    },
    buyingRules: {
        isActive: false,
        buyIf: '',
        rules: [],
    },
    selectedCurrency: null,

    // Wizard Location
    location: {
        nodes: [],
        countries: [],
        selectedCountries: [],
        regions: [],
        selectedRegions: [],
        cities: [],
        selectedCities: [],
        neighborhood: [],
        selectedNeighborhoods: [],
        zones: [],
    },

    mapLocations: {
        nodes: [],
        countries: [],
        selectedCountries: [],
        regions: [],
        selectedRegions: [],
        cities: [],
        selectedCities: [],
        neighborhood: [],
        selectedNeighborhoods: [],
        zones: [],
    },

    // Wizard Screens
    selectedScreens: [],
    proximityFilterEnabled: false,
    providerSource: ['tgx'],
    showSelectedScreens: false,
    selectedScreenTypes: [],
    selectedPublishers: [],
    expectedStats: {},
    // Wizard Audiences
    demographics: { id: 'onemata' },
    segments: {
        activeSegment: 'age',
        age: { value: [], sliderValue: [0, 99] },
        gender: ['male', 'female'],
        incomeLevel: ['low', 'mid', 'high'],
        interests: [],
        accuracy: { value: 'mid', sliderValue: 1 },
    },
    // Wizard Creatives
    baseName: '',
    sizesNeeded: [],
    tracking: {
        isActive: false,
        externalTracking: '',
    },
    totalSpent: 0,
    creatives: [],
    creativesDirty: false,
    selectedCreativeCategories: [],
    errors: [],
    canLaunch: false,
    isResizeMapOn: false,
    isResizeMapFullOn: false,
    stepper: { index: 0, wizard: 'basics' },
    currentWizard: 'basics',
    wasLaunched: false,
    currentPositionMap: null,
    status: '',
    isTest: false,
    isLaunching: false,
    label_id: null,
};

const { reducer, actions } = createSlice({
    name: 'newCampaign',
    initialState: initialState,
    reducers: {
        setMany(state, action) {
            let newDataCampaign = action.payload;
            state.totalSpent = newDataCampaign.totalSpent;
            state.name = newDataCampaign.name;
            state.id = newDataCampaign.id ? newDataCampaign.id : null;
            state.brand = newDataCampaign.brand;
            state.channels = newDataCampaign.channels;
            state.budget = newDataCampaign.budget;
            state.reduction = newDataCampaign.reduction;
            state.dailyCap = newDataCampaign.dailyCap;
            state.dailyCaps = newDataCampaign.dailyCaps || {
                isActive: false,
                caps: {},
            };
            state.buyingRules = newDataCampaign.buyingRules;
            state.location = newDataCampaign.location;
            state.mapLocations = newDataCampaign.mapLocations;
            state.selectedScreens = newDataCampaign.selectedScreens;
            state.proximityFilterEnabled =
                newDataCampaign.proximityFilterEnabled === true;
            state.providerSource = getCampaignProviderSource(
                { screen_providers: newDataCampaign.providerSource },
                newDataCampaign.selectedScreens
            );
            state.expectedStats = newDataCampaign.expectedStats || {};
            state.sizesNeeded = newDataCampaign.sizesNeeded;
            state.baseName = newDataCampaign.baseName;
            state.creatives = newDataCampaign.creatives;
            state.creativesDirty = false;
            state.selectedCreativeCategories =
                newDataCampaign.selectedCreativeCategories;
            state.errors = newDataCampaign.errors;
            state.canLaunch = newDataCampaign.canLaunch;
            state.timing = newDataCampaign.timing;
            state.segments = newDataCampaign.segments;
            state.tracking = newDataCampaign.tracking;
            state.selectedCurrency = newDataCampaign.selectedCurrency;
            state.demographics = newDataCampaign.demographics;
            if (newDataCampaign.status !== undefined) {
                state.status = newDataCampaign.status;
            }
            state.isTest = newDataCampaign.isTest;
            state.label_id = newDataCampaign.label_id;
        },
        setId(state, action) {
            state.id = action.payload;
        },
        setNodeAndCountries(state, action) {
            state.location.nodes = action.payload.nodes;
            state.location.countries = action.payload.countries;
        },
        setSelectedCountries(state, action) {
            state.location.selectedCountries = action.payload;
        },
        setName(state, action) {
            state.name = action.payload;
        },
        setBrand(state, action) {
            state.brand = action.payload;
        },
        setChannels(state, action) {
            state.channels = action.payload;
        },
        setBudget(state, action) {
            state.budget = action.payload;
        },
        setReduction(state, action) {
            state.reduction = action.payload;
        },
        setDailyCap(state, action) {
            state.dailyCap = action.payload;
        },
        setDailyCaps(state, action) {
            state.dailyCaps = action.payload;
        },
        setTiming(state, action) {
            const { id } = state.timing.selectedTimezone;
            if (id) {
                if (id !== action.payload.selectedTimezone?.id) {
                    action.payload.periodValue = null;
                }
            }
            state.timing = action.payload;
        },
        setBuyingRules(state, action) {
            state.buyingRules = action.payload;
        },
        setSelectedCurrency(state, action) {
            state.selectedCurrency = action.payload;
        },
        setLocation(state, action) {
            state.location = action.payload;
        },
        setMapLocations(state, action) {
            state.mapLocations = action.payload;
        },
        setProviderSource(state, action) {
            state.providerSource = action.payload;
        },
        setSelectedScreens(state, action) {
            state.selectedScreens = action.payload;
        },
        setProximityFilterEnabled(state, action) {
            state.proximityFilterEnabled = action.payload;
        },
        setShowSelectedScreens(state, action) {
            state.showSelectedScreens = action.payload;
        },
        setSelectedScreenTypes(state, action) {
            state.selectedScreenTypes = action.payload;
        },
        setSelectedPublishers(state, action) {
            state.selectedPublishers = action.payload;
        },
        setExpectedStats(state, action) {
            state.expectedStats = action.payload;
        },
        setDemographics(state, action) {
            state.demographics = action.payload;
        },
        setSegments(state, action) {
            state.segments = action.payload;
        },
        setBaseName(state, action) {
            state.baseName = action.payload;
        },
        setSizesNeeded(state, action) {
            state.sizesNeeded = action.payload;
        },
        setTracking(state, action) {
            state.tracking = action.payload;
        },
        setCreatives(state, action) {
            state.creatives = action.payload;
        },
        setCreativesDirty(state, action) {
            state.creativesDirty = action.payload;
        },
        setSelectedCreativeCategories(state, action) {
            state.selectedCreativeCategories = action.payload;
        },
        setErrors(state, action) {
            state.errors = action.payload;
        },
        setCanLaunch(state, action) {
            state.canLaunch = action.payload;
        },
        setIsResizeMapOn(state, action) {
            state.isResizeMapOn = action.payload;
        },
        setIsResizeMapFullOn(state, action) {
            state.isResizeMapFullOn = action.payload;
        },
        setStepper(state, action) {
            state.stepper = action.payload;
        },
        setCurrentWizard(state, action) {
            state.currentWizard = action.payload;
        },
        setWasLaunched(state, action) {
            state.wasLaunched = action.payload;
        },
        setCurrentPositionMap(state, action) {
            state.currentPositionMap = action.payload;
        },
        setStatus(state, action) {
            state.status = action.payload;
        },
        setIsTest(state, action) {
            state.isTest = action.payload;
        },
        setLocationZonesRadius(state, action) {
            const { i, j, value } = action.payload;
            state.location.zones[i].results[j].radius = value;
        },
        setIsLaunching(state, action) {
            state.isLaunching = action.payload;
        },
        setLocationZonesCenterToInitialValue(state, action) {
            const { i, j, lat, lng } = action.payload;
            state.location.zones[i].results[j].lat = lat;
            state.location.zones[i].results[j].lng = lng;
        },
        reset(state, action) {
            Object.keys(initialState).forEach((key) => {
                state[key] = initialState[key];
            });
        },
    },
});

export {
    actions as newCampaignActions,
    initialState as newCampaignInitialState,
    reducer as newCampaignReducer,
};
